<template>
  <div style="position: relative;">

    <div style="margin:0 0 5px;display: flex;justify-content:flex-end;width: 100%; ">
      <el-button type="primary" icon="el-icon-plus" size="small" @click="addHelp()">新增帮助</el-button>
    </div>

    <mytable
      :tableColums='tableColums_getSysKeyList'
      api='getSysHelpList'
      updateapi='updateSysHelp'
      :height="H-158" >
      <div slot="shTitle" slot-scope="{row}" v-text="row.shTitle" style="white-space:normal;line-height:1.8;"></div>
      <div slot="shContext" slot-scope="{row}" v-html="row.shContext" style="max-height: 30vh;overflow: hidden;max-width: 99%;"></div>
    </mytable>
    <myform view.updateSysHelp ></myform>
    <myform view.tinymce='富文本编辑器 - 全屏: 双击或点击最后一个按钮#el-icon-circle-check#保存'
      id="PromotionManage"
      width='85%' top='50px'
      @closed='row = null'
      opened="$event.title = row.skRemark + ' - 全屏: 双击或点击最后一个按钮'"
      @close='arguments[1] && (arguments[0].actived="")'
      @show='boolean=true,superEditor && superEditor.show( window.sleep(400,v=>superEditor.focus()) )'
      @confirm='superEditorUpload' >
       <!-- <div v-if='boolean'>{{ window.alert(5555) }}</div> -->
      <el-input placeholder="请输入标题" v-model="input" clearable size="medium" style="width:100%;"></el-input>
      <div v-if='boolean' >
        <tinymce v-model='string' xreadonly v-s.height='H-180' id='tinymce' ></tinymce>
      </div>
    </myform>
    <!-- <myformtwo
    style="width: 100%; height: 100%;">
    <h2 slot='one' slot-scope='user' >
     {{user.data}}
      </h2>

    </myformtwo> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      input:"",
      userId: null,

      tableColums_getSysKeyList: {
        $selection: false,
        shTitle: ['标题',200,],
        shContext: '内容',
        shOrder:["排序",80],
        $operation: this.updateSysHelp && [
          '操作', 140,

          this.updateSysHelp && `@text: 编辑#warn
            @click:
              $row.skId == 1
              ? $form("updateSysHelp",$row)
              : ( $form('tinymce'), string = ($this.row=$row).shContext + '',input =($this.row=$row).shTitle)
          `,
          this.deleteSysHelp && `@text:删除#danger+
            @click: dodel($row)
          `,
        ],
      },

    };
  },

  watch: {
    superEditor(superEditor) {
      superEditor.focus();
    },
  },

  methods: {
     addHelp(){
        this.input = this.string = '';
        $form('tinymce');
      },
      async dodel(row){
        if( !await this._confirm('你确认要删除这条帮助吗?') ) return;
        this.deleteSysHelp({
          shId:row.shId
        },'正在删除').result(res=>{
          if(!res) return;
          alertSuccess('删除成功!');
          this.getSysHelpList();
        });
      },
      async superEditorUpload() {
        if(this.input == "" || this.string == ""){
          return this.$message({
            showClose: true,
            message: '标题和内容不能为空',
            type: 'error'
          });
        };
        var html = await this.superEditor.upload(document.body); // this.$refs.reward.$el.firstElementChild
        //console.log(html);
        if( html !== html ) return;
        if(!this.row) {
          this.addSysHelp({
            shTitle: this.input,
            shContext: html,
            shOrder: 1
          },'正在提交').result(res=>{
            if(!res) return;
            alertSuccess('新增成功!');
            this.$form('tinymce','hide');
            this.getSysHelpList();
          });
        } else {
          this.updateSysHelp({
            shId:this.row.shId,
            shTitle:this.input,
            shContext:html,
            shOrder:this.row.shOrder
          },'正在更新').result(res=>{
            if(!res) return;
            alertSuccess('更新成功!');
            this.$form('tinymce','hide');
            this.getSysHelpList();
          });
        };

      },
  },

  created() {
    // console.warn(1);
    this.getSysHelpList();
  },

};
</script>


<style>
  #PromotionManage > .el-dialog__wrapper, #PromotionManage > .el-dialog__wrapper > [fullscreen] {
    overflow: hidden!important;
  }
  #PromotionManage [fullscreen] #tinymce {
    height: 90vh!important;
  }
  #PromotionManage .el-dialog__body {
    padding-top: 7px!important;
    padding-bottom: 0!important;
  }
  #PromotionManage .el-dialog__footer {
    padding: 0px 27px 25px!important;
  }
  #PromotionManage .el-button {
    position: absolute;
    top: 15px;
    right: 60px;
    border-radius: 50px;
    z-index: 777;
  }
</style>



// WEBPACK FOOTER //
// src/views/help/help.vue